import React from 'react'
import '../CSS/BookingPage.css'
import NavOnlyIcons from './NavOnlyIcons'
import SubFooter from './SubFooter'

const Booking_Page = () => {
    return (
    <>
        <div className='Booking' id='Booking'>
            <div className="dipNav">
                <NavOnlyIcons /> 
            </div>
            <div className="innerBookingDiv">          
            
                <div className="BookingPageOptions">
                    <h3><i className="fas fa-home"></i>Home</h3>
                    <h3><i className="fas fa-calendar-check"></i>Schedule</h3>
                    <h3><i className="fas fa-signal"></i>Progress</h3>
                </div>
                
            </div>
        </div>
        <SubFooter />   
    </>
    )
}

export default Booking_Page
